import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-right: 1px solid ", ";\n  border-left: 1px solid ", ";\n  border-bottom: 0px solid ", ";\n  border-top: 0px solid ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
var Body = styled.div(_templateObject(), function (p) {
  return p.brand ? p.theme[p.brand] : 'transparent';
}, function (p) {
  return p.brand ? p.theme[p.brand] : p.theme.grey7;
}, function (p) {
  return p.brand ? p.theme[p.brand] : p.theme.grey7;
}, function (p) {
  return p.brand ? p.theme[p.brand] : p.theme.grey7;
}, function (p) {
  return p.brand ? p.theme[p.brand] : p.theme.grey7;
}, function (p) {
  return p.brand ? p.theme.highContrast(p.theme[p.brand]) : p.theme.relativeBlack;
});

var CardBody = function CardBody(_ref) {
  var brand = _ref.brand,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Body, {
    brand: brand
  }, children);
};

export default CardBody;